import api from '@/services/api';

// initial state
const state = () => ({
  searchFormData: null,
  selectedRow: {
    id: '',
    descricao: '',
  },
  route: '',
  lastRoute: '',
  changedForm: false,
  modalVisible: false,
  disabledCache: false,
  results: [],
});

// getters
const getters = {
  getFormData: _state => _state.searchFormData,
  getSelectedRow: _state => _state.selectedRow,
};

// actions
const actions = {
  searchResult(context) {
    if (context.state.route == '') return;
    if (context.state.searchFormData == null) return;
    if (
      context.state.route == context.state.lastRoute
      && !context.state.changedForm
      && !context.state.disabledCache
    ) return;
    if (context.state.route != context.state.lastRoute) {
      context.commit('updateTable', []);
    }

    const params = {
      params: context.state.searchFormData,
    };

    api.get(context.state.route, params).then((response) => {
      let dados = response.data;
      if (dados.Entity) {
        dados = dados.Entity;
      }
      context.commit('updateTable', dados);

      context.commit('updateLastRoute', context.state.route);
      context.commit('setChangedForm', false);
    });
  },
};

// mutations
const mutations = {
  setFormData(_state, data) {
    if (_state.route != _state.lastRoute) {
      _state.searchFormData = data;
    }
  },
  setSelectedRow(_state, data) {
    _state.selectedRow = data;
  },
  setChangedForm(_state, data) {
    _state.changedForm = data;
  },
  setDisabledCache(_state, data) {
    _state.disabledCache = data;
  },
  updateForm(_state, data) {
    _state.changedForm = true;
    _state.searchFormData[data.field] = data.value;
  },
  updateRoute(_state, data) {
    _state.route = data;
  },
  updateLastRoute(_state, data) {
    _state.lastRoute = data;
  },
  updateTable(_state, data) {
    _state.results = data;
  },
  updateModalVisible(_state, data) {
    _state.modalVisible = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
